/* unplugin-vue-components disabled */import { render } from "./files-empty.vue?vue&type=template&id=429d7d8b&scoped=true"
import script from "./files-empty.vue?vue&type=script&setup=true&lang=js"
export * from "./files-empty.vue?vue&type=script&setup=true&lang=js"

import "./files-empty.vue?vue&type=style&index=0&id=429d7d8b&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-429d7d8b"],['__file',"src/pages/files/files-empty.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "429d7d8b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('429d7d8b', __exports__)) {
    api.reload('429d7d8b', __exports__)
  }
  
  module.hot.accept("./files-empty.vue?vue&type=template&id=429d7d8b&scoped=true", () => {
    api.rerender('429d7d8b', render)
  })

}


export default __exports__